import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Lead, LeadCreate, LeadFilter } from '../data/lead';

export function createLeadService(client: AxiosInstance) {
  return createCrudService<Lead, LeadCreate, LeadFilter>(
    client,
    '/crm/Lead',
    'id',
  );
}

export type LeadService = CrudService<Lead, LeadCreate, LeadFilter>;
